module.exports = __webpack_public_path__ + "img/numberQuotientRed.9b75261b.jpg";